document.addEventListener('DOMContentLoaded', function() {
  const buttonElements = document.querySelectorAll('.js-formModal');
  const formElement = document.querySelectorAll('.form-modal');
  const formOrganizer = document.querySelector('.form-organizer-modal');
  const closeElements = document.querySelectorAll('.js-closeFormModal');
  const openOrganizerFormModal = document.querySelectorAll('.js-openOrganizerFormModal');


  if (buttonElements.length) {
    buttonElements.forEach((buttonElement) => {
      buttonElement.addEventListener('click', () => {
        if (formElement.length) {
          formElement.forEach(el=>{
            el.classList.add('form-modal_open');
          })
        }
        document.body.classList.add('hidden-scroll');
      });
    });
  }

  if(openOrganizerFormModal.length){
    openOrganizerFormModal.forEach((buttonElement) => {
      buttonElement.addEventListener('click', () => {
        if (formOrganizer) {
          formOrganizer.classList.add('form-modal_open');
        }
        document.body.classList.add('hidden-scroll');
      });
    });
  }

  if (closeElements.length) {
    closeElements.forEach(btn => btn.addEventListener('click', () => {
      if (formElement.length) {
        formElement.forEach(el=>{
          el.classList.remove('form-modal_open');
        })
      }
      if (formOrganizer) {
        formOrganizer.classList.remove('form-modal_open');
      }
      document.body.classList.remove('hidden-scroll');
    }));
  }
});
